'use client'

import React from 'react'
import { Header } from '@/app/(frontend)/Header'
import NavbarTop from '@/components/client/navigation/NavbarTop'
import { useClientNavMode } from '@/components/client/navigation/clientNavMode'

export default function NavbarGate() {
  const navMode = useClientNavMode()

  if (navMode === 'pre-auth') {
    return <Header />
  }

  if (navMode === 'post-auth') {
    return (
      <header className="fixed top-0 inset-x-0 z-50">
        <div data-testid="navbar-top" className="navbar-top-wrapper w-full">
          <NavbarTop />
        </div>
      </header>
    )
  }

  return null
}
